import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

const SelectField = ({ name, label, error, ...props }) => {
	return (
		<FormControl
			className={props.className}
			variant={props.variant}
			fullWidth={props.fullWidth}
			error={error}
		>
			{label && <InputLabel htmlFor={name}>{label}</InputLabel>}
			<Select name={name} {...props} />
		</FormControl>
	);
};

SelectField.propTypes = {
	label: PropTypes.string,
	autoFocus: PropTypes.bool,
	fullWidth: PropTypes.bool,
	name: PropTypes.string.isRequired,
};
export default SelectField;
